import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0201 from "../lesson-01/lesson";
import lesson0202 from "../lesson-02/lesson";
import lesson0203 from "../lesson-03/lesson";
import lesson0204 from "../lesson-04/lesson";
import lesson0205 from "../lesson-05/lesson";
import lesson0207 from "../lesson-07/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "949a9d6f-7642-44e6-9bf0-37ad61024608",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0201),
    lesson: lesson0201,
  },
  {
    id: "d8706da5-355a-4b2c-8018-0a8d424fb9ad",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0202),
    lesson: lesson0202,
  },
  {
    id: "d39ba614-52be-40c7-9f91-ab1daede4847",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0203),
    lesson: lesson0203,
  },
  {
    id: "b123a963-a4f6-4c27-96ef-70de18c09310",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0204),
    lesson: lesson0204,
  },
  {
    id: "defde66d-65d1-4db5-936f-cd5e7a0a9bf7",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0205),
    lesson: lesson0205,
  },
  {
    id: "e021d460-2916-4bcd-b6c9-705b8809cf55",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0207),
    lesson: lesson0207,
  },
];

export default lessonLinks;
